import { mapKeys } from 'lodash'

const idFromName = (name: string) => name.replace(/\]/g, '').replace(/[^-a-zA-Z0-9:.]/g, '_')

const toDataAttributes = (dataSet: object = {}) =>
  mapKeys(dataSet, (value, key) => `data-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`)

export { idFromName, toDataAttributes }
